module.exports = __webpack_public_path__ + "static/media/ehealthpro_acc_mgmt_slider_phone1.4ca71558.png";